// extracted by mini-css-extract-plugin
export default {"trustpilot":"TrustPilotImage__trustpilot-kw9X"};